import { observable, action } from 'mobx';
import { FurtherConsiderations } from '../models';
import { FurtherConsiderationsStore } from './further-considerations-store';
import { LoadingStore } from './loading-store';

export class FurtherConsiderationsEntryStore {
  @observable furtherConsiderations: FurtherConsiderations = new FurtherConsiderations();

  // The in-flight (or completed) load. The FurtherConsiderations table is the
  // same multi-MB payload for every practitioner and is READ-ONLY from the app
  // (the Lambda exposes GET and nothing else), yet five containers each kicked
  // off their own fetch on mount — so every navigation, and the TermsModal
  // firing alongside the analysis container, re-downloaded the whole table.
  // Holding the promise makes concurrent callers share one request and later
  // callers resolve instantly. Deliberately NOT cleared on success: the table
  // only changes when the upload scripts run, which is followed by a reload.
  private loadPromise?: Promise<FurtherConsiderations>;

  constructor(private furtherConsiderationsStore: FurtherConsiderationsStore, private loadingStore: LoadingStore) {
  }

  @action loadFurtherConsiderations(): Promise<FurtherConsiderations> {
    if (this.loadPromise) {
      return this.loadPromise;
    }

    this.loadingStore.appIsBusy();
    this.loadPromise = this.furtherConsiderationsStore.loadFurtherConsiderations().then((furtherConsiderations) => {
      this.furtherConsiderations = furtherConsiderations;
      this.loadingStore.appIsNotBusy();
      return this.furtherConsiderations;
    }, (error: any) => {
      console.error(error);
      // A failed load must NOT stick, or one network blip would leave the
      // session permanently without considerations. Dropping the cached
      // promise lets the next mount retry, which is what happened before.
      this.loadPromise = undefined;
      this.loadingStore.appIsNotBusy();
      // TODO: Determine the best way to handle errors
      return new FurtherConsiderations();
    });
    return this.loadPromise;
  }
}